export default {
  fetchUser() {
    return axios.get('/api/me').then(response => response.data);
  },
};